import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Button,
  Skeleton,
  Avatar,
} from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { api } from "../../utils/api";

export default function Audit() {
  const [auditList, setAuditList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await api.get("/audit/pending.php");
      setAuditList(res.audit || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const act = async (item, action) => {
    const { value: remark } = await Swal.fire({
      title: action === "approve" ? "Approve?" : "Reject?",
      input: "textarea",
      inputLabel: "Remark (optional)",
      showCancelButton: true,
      confirmButtonText: action === "approve" ? "Approve" : "Reject",
      confirmButtonColor: action === "approve" ? "#16a34a" : "#dc2626",
    });
    if (remark === undefined) return;
    try {
      await api.post("/workflow/action.php", {
        job_service_id: item.job_service_id || item.id,
        action,
        remark,
      });
      Swal.fire({
        icon: "success",
        title: action === "approve" ? "Approved" : "Rejected",
        timer: 1200,
        showConfirmButton: false,
      });
      load();
    } catch (e) {
      Swal.fire({ icon: "error", title: "Failed", text: e.message });
    }
  };

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
        <Avatar sx={{ bgcolor: "success.main", width: 48, height: 48 }}>
          <VerifiedIcon />
        </Avatar>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>
            Audit Queue
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Tasks pending your review & approval
          </Typography>
        </Box>
      </Stack>

      {loading && (
        <Stack spacing={2}>
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} variant="rounded" height={100} />
          ))}
        </Stack>
      )}

      {!loading && auditList.length === 0 && (
        <Paper sx={{ p: 6, textAlign: "center" }}>
          <Typography variant="body2" color="text.secondary">
            No tasks pending for audit 🎉
          </Typography>
        </Paper>
      )}

      <Stack spacing={2}>
        {!loading &&
          auditList.map((a) => (
            <Paper key={a.id} sx={{ p: 2.5 }}>
              <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                alignItems={{ md: "center" }}
                spacing={2}
              >
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                    {a.task_name || a.service_name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Client: <b>{a.client_name}</b> · Service:{" "}
                    <b>{a.service_name}</b>
                  </Typography>
                  <Typography variant="caption" color="text.disabled">
                    Submitted: {a.submitted_at || "—"}
                  </Typography>
                </Box>
                <Stack direction="row" spacing={1}>
                  <Button
                    size="small"
                    variant="contained"
                    color="success"
                    startIcon={<CheckIcon />}
                    onClick={() => act(a, "approve")}
                  >
                    Approve
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    color="error"
                    startIcon={<CloseIcon />}
                    onClick={() => act(a, "reject")}
                  >
                    Reject
                  </Button>
                </Stack>
              </Stack>
            </Paper>
          ))}
      </Stack>
    </Box>
  );
}
